export enum DataType {
    article = 1,
    page = 2,
    divider = 3,
    // searchBar: 4,
    myLastTitles = 5,
    replies = 6,
    initBlock = 7,
    // breakingNews: 8,
    // title: 9,
    // leftBar: 10,
    monitors = 11,
    profile = 12,
    opinion = 13,
    homeBlock = 14,
    adBlock = 16,
    social = 17,
    bookmarkPages = 18,
    recommendedOpinions = 19,
    promoSection = 20,
    post = 21,
    gift = 22,
    // 23 occupied by SessionStarted block
    ctaSignUpSection = 24,
    giftVideoAd = 25,
    ctaOnboarding = 26,
    info = 27,
}
